import { ThemeOptions } from '@mui/material';

const customGrey = {
  medium: '#DBD7D1',
  light: '#F6F5F3',
  dark: '#28272C'
};

const aiColours = {
  green: '#64DBAE',
  orange: '#FF8164'
};

const primaryColorDefault = '#7A6AFF';

export const paletteStyles = ({
  primaryColor = primaryColorDefault
}: {
  primaryColor?: string;
}): NonNullable<ThemeOptions['palette']> => {
  return {
    primary: {
      main: primaryColor,
      light: '#E4E1FF'
    },

    customGrey: {
      medium: customGrey.medium,
      light: customGrey.light,
      dark: customGrey.dark
    },

    aiColours,
    aiGradient: `linear-gradient(92deg, ${primaryColorDefault} 9.14%, ${aiColours.green} 33%, ${aiColours.orange} 61.64%, ${primaryColorDefault} 99.81%)`,
    white: 'white',
    divider: customGrey.dark,

    secondary: {
      main: '#DBEBFC',
      contrastText: '#4773A3'
    },
    info: {
      main: '#DBEBFC',
      contrastText: '#4773A3'
    },
    warning: {
      main: '#FFF7EE',
      dark: '#924D00',
      contrastText: '#924D00',
      light: '#FFD057'
    },
    background: {
      default: '#FFFFFF'
    },
    text: {
      primary: '#504955',
      secondary: '#8C8393'
    },
    // Error Red in Figma
    error: {
      main: '#DC262F',
      light: '#FFEEEA'
    },
    // Success Green in Figma
    successV2: {
      main: '#00A016',
      light: '#EBFCEA'
    },
    // Warning Yellow in Figma
    warningV2: {
      main: '#FFD057',
      light: '#FFF7EE',
      dark: '#924D00'
    },
    border: {
      large: {
        primary: {
          main: `3px solid ${primaryColor}`
        }
      },
      small: {
        grey: {
          medium: `1px solid ${customGrey.medium}`,
          dark: `1px solid ${customGrey.dark}`
        },
        error: {
          main: '1px solid #DC262F'
        },
        warning: {
          dark: '1px solid #924D00'
        }
      }
    },
    black: '#000000',
    /**
     * @deprecated
     */
    success: {
      main: '#EBFCEA',
      dark: '#00A016',
      contrastText: '#008A00'
    },
    /**
     * @deprecated
     */
    default: '#8C8393',
    /**
     * @deprecated
     */
    tertiary: {
      main: '#C8E2FF'
    },
    /**
     * @deprecated
     */
    poppGrey: {
      main: '#504955',
      light: '#8C8393'
    }
  };
};
